import DenominationBaseController from '../common/denomination.base.controller'
import AppConstatnt from '../../../../../config/app.constants';

class DenominationCreateController extends DenominationBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, DenominationService, Modal, $translate, $stateParams, $q, ShiptypeService, CurrencyService, SetupService, $scope) {

        super(Auth, $state, User, DenominationService, Modal, $translate, $stateParams)
        this.CurrencyService = CurrencyService;
        this.ShiptypeService = ShiptypeService;
        this.SetupService = SetupService;
        this.$q = $q;
        this.$scope = $scope;
        this.hasACL = {};
        this.shiptypeMismatch = false;

        this.defaultModel = {
            id: '',
            name: '',
            faceValue: '',
            currencyId: null,
            shiptypeId: null,
            icon: '',
            coinFlag: false,
            sortOrder: 1,
            strapCount: 100,
            bundleCount: 10,
            loadDetectThreshold: null,
            coinPackaging: null,
            multiDenomPackable: false,
            unfit: false,
            individualDenominationId: null,
            selectedFiles:[]
        };
        this.loading = false;
        this.model = angular.copy(this.defaultModel);
        this.branchId = this.User.getUser().branchId;

        this.$scope.$watchGroup([
            () => this.model.id,
            () => this.model.shiptypeId,
            () => this.model.coinFlag
        ], () => this.validateShiptypeMatch());
    }

    validateShiptypeMatch() {
        const MISMATCH_MESSAGE = 'Denomination ID and Shiptype ID must be set to the same value';
        this.shiptypeMismatch = !!(this.model.coinFlag && this.model.id && this.model.shiptypeId && this.model.shiptypeId.Value
            && this.model.shiptypeId.Value !== this.model.id);

        if (this.shiptypeMismatch) {
            this.errorMessage = MISMATCH_MESSAGE;
        } else if (this.errorMessage === MISMATCH_MESSAGE) {
            this.errorMessage = '';
        }
    }

    $onInit() {
        this.$q.all([
            this.loadshiptype('', 0),
            this.loadDenomination('', 0),
            this.CurrencyService.all(null, 0, 100),
            this.SetupService.get(this.branchId)
        ])
            .then((data) => {
                // this.shiptypeData = data[0].results;
                const availableCurrencyIds = data[3].availableCurrencyIds ? data[3].availableCurrencyIds : [];
                this.currencyData = data[2].results.filter(currency => availableCurrencyIds.includes(currency.id));    
            })
            .catch((err) => {
                console.log(err);
            })
    }

    // load all shiptype
    loadshiptype(searchKey, offset) {

        searchKey = searchKey || '';

        const shiptypeSearchObj = {
            queryJSON: {
                rules: [
                    {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'description',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            },
        }

        this.ShiptypeService.all(shiptypeSearchObj, offset, AppConstatnt.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.totalRecords = data.total;
                    this.shiptypeList = this.mappingShiptypeData(data.results);
                }
                else {
                    const shiptype = this.mappingShiptypeData(data.results);
                    this.shiptypeList = this.shiptypeList.concat(shiptype);
                }
            })
    }

    mappingShiptypeData(shiptype) {
        return shiptype.map((shiptypes) => {
            return {
                Key: shiptypes.id + " | " + shiptypes.description,
                Value: shiptypes.id
            }
        });
    }

    loadDenomination(searchKey, offset) {

        searchKey = searchKey || '';

        const denominationSearchObj = {
            queryJSON: {
                rules: [
                    {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            },
        }

        this.Service.all(denominationSearchObj, offset, AppConstatnt.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.totalDenominationRecords = data.total;
                    this.denominationList = this.mappingDenominationData(data.results);
                }
                else {
                    const denomination = this.mappingDenominationData(data.results);
                    this.denominationList = this.denominationList.concat(denomination);
                }
            })
    }

    mappingDenominationData(denominations) {
        return denominations.map((denom) => {
            return {
                Key: denom.id + " | " + denom.name,
                Value: denom.id
            }
        });
    }

    isMultiDenomPackableAllowed() {
        if (!this.model.coinFlag) {
            return true;
        }
        if (this.model.coinPackaging && ['INDIVIDUAL','ROLLED'].includes(this.model.coinPackaging)) {
            return true;
        }
        return false;
    }

    onCoinPackagingChange() {
        if (!this.isMultiDenomPackableAllowed()) {
            this.model.multiDenomPackable = false;
        }
    }

    onCoinFlagChange() {
        if (!this.model.coinFlag) {
            return;
        }
        if (!this.isMultiDenomPackableAllowed()) {
            this.model.multiDenomPackable = false;
        }
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.clearErrors();
    }

    submit() {
        this.loading = true;
        let denominationIcon = [];
        if (this.model.selectedFiles && this.model.selectedFiles.length) {
            this.model.selectedFiles.forEach((d) => {
                denominationIcon.push({ base64String: d.base64Data, fileName: `${this.rawId}.png`});
            })
        }
        this.Service.create({
            id: this.model.id,
            name: this.model.name,
            faceValue: this.model.faceValue,
            icon: this.model.icon ? this.model.icon : null,
            sortOrder: this.model.sortOrder,
            currencyId: this.model.currencyId,
            shiptypeId: this.model.shiptypeId.Value,
            strapCount: ( this.model.coinFlag || this.model.strapCount === '' || this.model.strapCount === undefined) ? 0 : Number(this.model.strapCount),
            bundleCount: (this.model.coinFlag || this.model.bundleCount === '' || this.model.bundleCount === undefined) ? 0 : Number(this.model.bundleCount),
            loadDetectThreshold: this.model.loadDetectThreshold || 0,
            coinFlag: this.model.coinFlag,
            coinPackaging: this.model.coinFlag ? this.model.coinPackaging : null,
            multiDenomPackable: this.isMultiDenomPackableAllowed() ? (this.model.multiDenomPackable || false) : false,
            unfit: this.model.unfit || false,
            individualDenominationId: (this.model.individualDenominationId && this.model.individualDenominationId.Value && this.model.coinFlag && this.model.coinPackaging !== 'INDIVIDUAL') ? this.model.individualDenominationId.Value : null,
            denominationIcon
        }, this.branchId)
            .then((data) => {
                this.loading = false;
                this.askCreate();
            })
            .catch((err) => {
                this.loading = false;
                if (err && err.data && err.data.errors) {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                }
                else {
                    this.errorMessage = this.$translate.instant(err.data.message);
                }
            })
    }

    calculateCount(type) {
        if (type === 'strapCount') {
            this.model.strapCount = this.model.bundleCount * 10;
        } else {
            this.model.bundleCount = this.model.strapCount / 10;
        }
    }
}

export default DenominationCreateController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/create/denomination.create.controller.js